<template>
  <div>
    <Topnav />
    <v-row>
      <v-col
        v-if="leftNavbar"
        cols="12"
        md="2"
      >
        <Leftnav />
      </v-col>
      <v-col
        :class="leftNavbar? 'container-fluid pr-12':'container-fluid px-12'"
        cols="12"
        md=""
      >
        <br>
        <br>
        <v-tabs
          background-color="grey darken-3"
          dark
        >
          <!-- My Tasks Tab -->
          <v-tab
            class="title"
          >
            <v-icon class="mx-2">mdi-account</v-icon>
            <span>我的任务</span>
          </v-tab>

          <!-- Unassigned Tasks Tab -->
          <v-tab
            v-show="tabShow"
            class="title"
          >
            <v-icon class="mx-2">mdi-clipboard</v-icon>
            <span>未分配任务</span>
          </v-tab>

          <!-- Assigned Tasks Tab -->
          <v-tab
            v-show="tabShow"
            class="title"
          >
            <v-icon class="mx-2">mdi-clipboard-list</v-icon>
            <span>已分配任务</span>
          </v-tab>

          <!-- My Tasks Page -->
          <v-tab-item>
            <v-card
              class="pa-3"
              elevation="6"
            >
              <template>
                <v-data-table
                  :headers="headers"
                  :items="indexMyItems"
                  :search="Mysearch"
                  sort-by="prod_code"
                >
                  <template v-slot:top>
                    <v-toolbar class="mb-3 pt-2" flat color="white">
                      <v-toolbar-title class="font-weight-bold">{{ tableTitle }}</v-toolbar-title>
                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>
                      <v-toolbar-title>
                        <v-text-field
                          v-model="Mysearch"
                          append-icon="mdi-magnify"
                          label="检 索 ..."
                          single-line
                          hide-details
                        ></v-text-field>
                      </v-toolbar-title>
                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <br>
                    <v-divider></v-divider>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      icon
                      small
                      @click="editItem(item._id)"
                    >
                      <v-icon
                        small
                      >
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:no-data>
                    <div>没有 {{ addIdentity }}</div>
                  </template>
                </v-data-table>
              </template>
            </v-card>
          </v-tab-item>

          <!-- Unassigned Tasks Page -->
          <v-tab-item>
            <v-card
              v-show="tabShow"
              class="pa-3"
              elevation="6"
            >
              <template>
                <v-data-table
                  :headers="headers"
                  :items="indexUnassignItems"
                  :search="Unassignsearch"
                  sort-by="prod_code"
                >
                  <template v-slot:top>
                    <v-toolbar class="mb-3 pt-2" flat color="white">
                      <v-toolbar-title class="font-weight-bold">{{ tableTitle }}</v-toolbar-title>
                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>
                      <v-toolbar-title>
                        <v-text-field
                          v-model="Unassignsearch"
                          append-icon="mdi-magnify"
                          label="检 索 ..."
                          single-line
                          hide-details
                        ></v-text-field>
                      </v-toolbar-title>
                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <br>
                    <v-divider></v-divider>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      icon
                      small
                      @click="editItem(item._id)"
                    >
                      <v-icon
                        small
                      >
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:no-data>
                    <div>没有 {{ addIdentity }}</div>
                  </template>
                </v-data-table>
              </template>
            </v-card>
          </v-tab-item>

          <!-- Assigned Tasks Page -->
          <v-tab-item>
            <v-card
              v-show="tabShow"
              class="pa-3"
              elevation="6"
            >
              <template>
                <v-data-table
                  :headers="headers"
                  :items="indexAssignedItems"
                  :search="Assignedsearch"
                  sort-by="prod_code"
                >
                  <template v-slot:top>
                    <v-toolbar class="mb-3 pt-2" flat color="white">
                      <v-toolbar-title class="font-weight-bold">{{ tableTitle }}</v-toolbar-title>
                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>
                      <v-toolbar-title>
                        <v-text-field
                          v-model="Assignedsearch"
                          append-icon="mdi-magnify"
                          label="检 索 ..."
                          single-line
                          hide-details
                        ></v-text-field>
                      </v-toolbar-title>
                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <br>
                    <v-divider></v-divider>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      icon
                      small
                      @click="editItem(item._id)"
                    >
                      <v-icon
                        small
                      >
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:no-data>
                    <div>没有 {{ addIdentity }}</div>
                  </template>
                </v-data-table>
              </template>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import Topnav from '@/components/TopNavbar.vue'
import Leftnav from '@/components/LeftNavbar.vue'
import Common from '@/components/common.vue'

export default {
  name: 'QualityIndex',
  components: {
    Topnav,
    Leftnav
  },
  data: () => ({
    leftNavbar: false,
    indexURL: Common.baseURL + 'produce/index',
    addURL: Common.baseURL + 'produce/new',
    editURL: Common.baseURL + 'produce/edit',
    tableTitle: '质检记录',
    addIdentity: '质检记录',
    headers: [
      { text: '生产批号', value: 'prod_code' },
      { text: '试剂盒名称', value: 'kitname' },
      { text: '试剂盒数量', value: 'quantity' },
      { text: '质检负责人', value: 'quality_principal' },
      { text: '质检申请', value: 'apply_status' },
      { text: '中检结果', value: 'middle_exam_result' },
      { text: '终检结果', value: 'final_exam_result' },
      { text: '操 作', align: 'right', value: 'actions', sortable: false },
    ],

    userRole: '',
    username: '',
    department: '',
    position: '',
    indexMyItems: [],
    indexUnassignItems: [],
    indexAssignedItems: [],

    Mysearch: '',
    Unassignsearch: '',
    Assignedsearch: '',

    tabShow: false

  }),

  computed: {
  },
  
  watch: {
  },

  created () {
    this.initialize()
  },

  methods: {
    show() {

    },
    initialize () {
      this.userRole = sessionStorage.getItem('role')
      this.username = sessionStorage.getItem('username')
      this.position = sessionStorage.getItem('position')
      this.department = sessionStorage.getItem('department')
      if (this.userRole == undefined) {
        console.log('need to login');
      }
      else if (this.userRole.indexOf('admin') != -1) {
        this.leftNavbar = true
      }
      if (this.position != '职员') {
        this.tabShow = true
      }
      axios.get(this.indexURL)
        .then(response => {
          console.log(response.status);
          for (var key in response.data) {
            var val = response.data[key]

            // Apply Status
            if (val['middle_exam_apply'] == '' && val['middle_exam_result'] == '') {
              continue
            }
            if (val['middle_exam_apply'] == true && val['middle_exam_result'] != '合格') {
              val['apply_status'] = '中期质检申请'
            } else if (val['final_exam_apply'] == true && val['final_exam_result'] != '合格') {
              val['apply_status'] = '最终质检申请'
            } else {
              val['apply_status'] = '无申请'
            }

            if (val['quality_principal'] == this.username) {
              this.indexMyItems.push(val)
            }
            else if (val['quality_principal'] == '') {
              this.indexUnassignItems.push(val)
            }
            else if (val['quality_principal'] != this.username || val['quality_principal'] != '') {
              this.indexAssignedItems.push(val)
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    editItem (id) {
      this.$router.push({name: 'ProductionEdit', query: { prod_id: id }})
    }
  },
}
</script>